import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '重庆市“粒粒皆辛苦”青少年短视频大赛';
const baseUrl = '20201130DSPDS';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/home`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'home',
      name: `${baseUrl}-home`,
      component: () => import('./pages/Home.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 2,
      },
    },
    {
      path: 'rules',
      name: `${baseUrl}-rules`,
      component: () => import('./pages/Rules.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'news',
      name: `${baseUrl}-news`,
      component: () => import('./pages/NewsList.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'new_apply',
      name: `${baseUrl}-apply`,
      component: () => import('./pages/Apply.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'detail',
      name: `${baseUrl}-detail`,
      component: () => import('./pages/Detail.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 3,
      },
    },
    {
      path: 'rank',
      name: `${baseUrl}-rank`,
      component: () => import('./pages/Rank.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'user',
      name: `${baseUrl}-user`,
      component: () => import('./pages/User.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
